module.exports = __webpack_public_path__ + "static/media/dsr_multi.be38d35c.png";